var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("span", { domProps: { innerHTML: _vm._s(_vm.translatedText) } }),
    _vm._v(" "),
    _vm.needTranslate
      ? _c("span", [
          !_vm.isTranslated && !_vm.translate_now
            ? _c(
                "a",
                {
                  staticStyle: { color: "blue", cursor: "pointer" },
                  on: { click: _vm.translate }
                },
                [_vm._v("translate")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMessage
            ? _c("span", { staticClass: "alert-danger" }, [
                _vm._v(_vm._s(_vm.errorMessage))
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ed0c09", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ed0c09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/TranslatableText.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-15ed0c09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/TranslatableText.vue
// module chunks = 0